import React from 'react';
import Popup from 'react-popup';
import PropTypes from 'prop-types';

const TooltipMobile = ({ tooltip, ok }) => (
  <div className="pp-tool-tip">
    <div className="pp-tool-tip-msg">{tooltip}</div>
    <hr className="hr" />
    <button className="ok" role="link" onClick={() => Popup.close()}>{ok}</button>
  </div>
);

TooltipMobile.propTypes = {
  tooltip: PropTypes.string.isRequired,
  ok: PropTypes.string.isRequired,
};
export default TooltipMobile;
